import React from 'react'

export default function Welcome(props) {
    return (
        <div>
            <div id="borderimg">
                <h1> Welcome to Jeopardy </h1>
            </div>
        </div>
    )
}